import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=5726800c&scoped=true&lang=pug"
import script from "./registration-form.vue?vue&type=script&lang=js"
export * from "./registration-form.vue?vue&type=script&lang=js"
import style0 from "./registration-form.vue?vue&type=style&index=0&id=5726800c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5726800c",
  null
  
)

export default component.exports